const NextI18Next = require('next-i18next').default;
const config = require('../i18n-config');
const Nexti18n = new NextI18Next(config);

module.exports = Nexti18n;